import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25bfd79c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar-slider-parent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hide-mobile" }, "前へ", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "navbar-slider" }
const _hoisted_6 = { class: "current" }
const _hoisted_7 = { class: "hide-mobile" }
const _hoisted_8 = { class: "hide-desktop" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hide-mobile" }, "次へ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      style: _normalizeStyle([_ctx.currentTab <= 0 ? { visibility: 'hidden' } : { visibility: 'visible' }]),
      id: "prev-button",
      class: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPrevClick && _ctx.onPrevClick(...args)))
    }, _hoisted_4, 4),
    _createElementVNode("ol", _hoisted_5, [
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.desktopTabs[_ctx.currentTab]), 1),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.mobileTabs[_ctx.currentTab]), 1)
      ])
    ]),
    _createElementVNode("button", {
      style: _normalizeStyle([_ctx.currentTab >= _ctx.desktopTabs.length - 1 ? { visibility: 'hidden' } : { visibility: 'visible' }]),
      id: "next-button",
      class: "button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNextClick && _ctx.onNextClick(...args)))
    }, _hoisted_11, 4)
  ]))
}